export default {
  General: {
    Email: "이메일",
    Send: "전송",
    Done: "완료",
    Finish: "완료",
    Try_again: "다시 시도",
    or: "또는"
  },
  SamsungType: {
    bixby: "Bixby 사용",
    no_bixby: "Bixby 미사용",
    home_button: "홈 버튼 사용"
  },
  sendEmail: {
    repair_tip1: "이 모델은 모바일 앱으로 수리할 수 없습니다. 데스크톱 솔루션을 이메일로 보내 드리겠습니다.",
    check_tip1: "모바일 앱만으로는 기기 검사를 완료할 수 없습니다. 데스크톱 솔루션을 이메일로 보내드리겠습니다.",
    tip1: "이 모델은 모바일 앱에서 잠금 해제할 수 없습니다. 이메일을 통해 데스크톱 솔루션을 보내드립니다.",
    tip2: "성공률을 높이려면 데이터 케이블을 사용하여 휴대폰을 컴퓨터에 연결하세요.",
    enter_address: "이메일 주소를 입력하세요.",
    enter_correct_address: "올바른 이메일 주소를 입력해 주세요.",
    confidential: "귀하의 이메일 주소는 엄격하게 기밀로 유지됩니다.",
    open_link: "Dr.Fone을 다운로드하려면 컴퓨터 브라우저에서 {0}을 엽니다.",
    has_sent: "이메일이 전송되었습니다.",
    almost: "거의 다 왔습니다.",
    step1: "1단계",
    open_email: "컴퓨터에서 이메일을 열고 전송된 링크로 Dr.Fone의 데스크톱 버전을 다운로드합니다.",
    step2: "2단계",
    repair_launch_tip: "Dr.Fone System Repair를 실행하고 계정에 로그인하여 수리 기능을 사용하십시오.",
    check_launch_tip: "Dr.Fone 데스크톱 버전을 설치하고 같은 계정으로 로그인하세요. \"My Device\"를 클릭한 다음 화면의 안내에 따라 기기를 연결하세요. 연결이 완료되면 \"Device Detail\"을 클릭하여 자세한 검사 결과를 확인하세요.",
    launch_tip: "Dr.Fone 잠금 해제를 실행하여 계정에 로그인하여 잠금 해제 기능을 사용하세요.",
    contact_us: "도움이 필요하면 문의하세요."
  },
  Unlock: {
    recoveryMode: "장치를 복구 모드로 전환",
    wipe_cache: "장치에서 캐시 파티션 삭제",
    wipe_data: "지침에 따라 장치의 데이터를 지웁니다.",
    completed: "잠금 해제 완료",
    completed_tip: "장치가 화면 잠금을 성공적으로 제거했는지 확인합니다. 그렇지 않으면 다시 시도하세요.",
    contact_us: "잠금 해제에 실패했습니까? 더 많은 도움이 필요하면 문의하세요."
  },
  UnlockStep: {
    sa1: "1. 휴대폰 전원을 끄고 휴대폰을 컴퓨터에 연결한 상태로 둡니다. ",
    sa2: "2. 볼륨 높이기 + Bixby + 전원 버튼을 동시에 길게 누릅니다.",
    sa3: "3. Samsung 로고가 나타나면 버튼을 놓고 몇 초 동안 기다립니다.",
    sa4: "4. 이제 장치가 복구 모드로 부팅됩니다. ‘부트로더로 재부팅’을 선택하면 다운로드 모드가 시작됩니다.",
    sb1: "1. 휴대폰 전원을 끄고 휴대폰을 컴퓨터에 연결한 상태로 둡니다.",
    sb2: "2. 전원 및 볼륨 높이기 버튼을 동시에 길게 누릅니다.",
    sb3: "3. 장치가 다시 부팅을 시작한 후에도 이 두 버튼을 계속 누르고 있습니다.",
    sb4: "4. 이제 장치가 복구 모드로 부팅됩니다. ‘부트로더로 재부팅’을 선택하면 다운로드 모드가 시작됩니다.",
    sc1: "1. 휴대폰 전원을 끄고 휴대폰을 컴퓨터에 연결한 상태로 둡니다.",
    sc2: "2. 볼륨 높이기 + 홈 + 전원 버튼을 동시에 길게 누릅니다.",
    sc3: "3. Samsung 로고가 나타나면 버튼을 놓고 몇 초 동안 기다립니다.",
    sc4: "4. 이제 장치가 복구 모드로 부팅됩니다. ‘부트로더로 재부팅’을 선택하면 다운로드 모드가 시작됩니다.",
    s5: "5. 볼륨 버튼을 눌러 '데이터 삭제/공장 초기화'를 선택한 다음 전원 버튼을 눌러 확인합니다.",
    s6: "6. 볼륨 버튼을 눌러 '예'를 선택한 다음 전원 버튼을 눌러 확인합니다.",
    s7: "7. '캐시 파티션 삭제'를 누른 다음 '예'를 선택합니다.",
    s8: "8. '지금 시스템 재부팅'을 선택하고 전원 버튼을 눌러 확인합니다. 장치를 재부팅하는 데 다소 시간이 걸립니다.",
    common1: "휴대폰의 전원을 끕니다.",
    common2: "볼륨 높이기 및 전원 버튼을 몇 초 동안 누릅니다.",
    common3: "화면에 복구 모드가 나타나면 모든 버튼을 놓습니다.",
    m4: "볼륨 버튼과 전원 버튼을 사용하여 '데이터 삭제'를 선택하여 수락합니다.",
    m5: "'모든 데이터 삭제'를 선택합니다.",
    m6: "이제 '확인'을 선택하고 프로세스가 끝날 때까지 기다립니다.",
    m7: "전원 버튼을 사용하여 기본 메뉴로 돌아갑니다.",
    m8: "'재부팅'을 선택합니다.",
    m9: "마지막으로 '시스템 재부팅'을 선택합니다.",
    h4: "볼륨 버튼과 전원 버튼을 사용하여 '데이터 삭제'를 선택하여 수락합니다.",
    h5: "'공장 초기화'를 선택합니다.",
    h6: "단어 '예'를 입력한 다음 '공장 초기화'를 선택합니다.",
    h7: "이 작업을 수행하는 동안 모든 파일이 제거됩니다.",
    h8: "기본 메뉴로 돌아가려면 '뒤로'를 선택하세요.",
    h9: "마지막으로 '다시 시작'을 선택합니다."
  }
};
